export type EstadoSalvamento = 'ocioso' | 'salvando' | 'salvo' | 'erro'
export type EventoSalvamento = 'iniciou' | 'concluiu' | 'falhou' | 'expirou'

export interface AparenciaBotao {
  rotulo: string
  desabilitado: boolean
  variante: 'normal' | 'sucesso' | 'erro'
}

export function proximoEstado(
  atual: EstadoSalvamento,
  evento: EventoSalvamento,
): EstadoSalvamento {
  if (evento === 'iniciou') return 'salvando'
  if (evento === 'concluiu') return atual === 'salvando' ? 'salvo' : atual
  if (evento === 'falhou') return atual === 'salvando' ? 'erro' : atual
  // expirou: so o sucesso some sozinho. O erro fica ate a proxima tentativa,
  // porque erro que some sozinho passa despercebido (D5 da spec).
  return atual === 'salvo' ? 'ocioso' : atual
}

export function aparenciaDoBotao(
  estado: EstadoSalvamento,
  rotuloPadrao: string,
  temPendencias: boolean,
): AparenciaBotao {
  if (estado === 'salvando') {
    return { rotulo: 'Salvando…', desabilitado: true, variante: 'normal' }
  }
  if (estado === 'salvo') {
    // O dado foi gravado no aparelho; enquanto houver fila, ainda nao subiu.
    return {
      rotulo: temPendencias ? '✓ Salvo — falta enviar' : '✓ Salvo',
      desabilitado: false,
      variante: 'sucesso',
    }
  }
  if (estado === 'erro') {
    return { rotulo: 'Erro ao salvar', desabilitado: false, variante: 'erro' }
  }
  return { rotulo: rotuloPadrao, desabilitado: false, variante: 'normal' }
}
